/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\CompanyService\CompanyService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday July 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 5th September 2023 04:50:18
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Axios from "axios";
import Config from "Config/Config";
import { CompanyDataUpdate } from "Type/company.type";
import generalQueryParams from "Type/params.type";
import { buildAxiosHeader, buildAxiosHeaderFile } from "Utils/Request.utils";

class CompanyService {
    static async getCompanyByID(id: string, params: generalQueryParams) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.COMPANIES}/${id}`;
        const company = await Axios.get(myUrl, buildAxiosHeader());
        return company.data;
    };

    static async getAutobuyCompanies() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.COMPANIES}/mine`;
        const company = await Axios.get(myUrl, buildAxiosHeader());
        return company.data;
    };

    static async getAllCompanies() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.COMPANIES}`;
        const myRet = await Axios.get(myUrl, buildAxiosHeader());
        return myRet.data;
    }

    static async createCompany(data: CompanyDataUpdate) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.COMPANIES}`;
        const myRet = await Axios.post(myUrl, data, buildAxiosHeaderFile());
        return myRet.data;
    }

    static async updateCompany(companyID: string, data: CompanyDataUpdate) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.COMPANIES}/${companyID}`;
        const myRet = await Axios.put(myUrl, data, buildAxiosHeader());
        return myRet.data;
    }

    static async getCompanyBySearch(search: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.COMPANIES}/search/${search}`;
        try {
            const myRet = await Axios.get(myUrl, buildAxiosHeader());
            if (myRet.data) {
                return myRet.data.map((v: any ) => {return {label: v.Name, result: v}});
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    }

};

export default CompanyService;
